import { Question } from './question.model';
import { StsNotification } from './sts-notification.model';

export class QAndA {
    QuestionId: string; // <-- hmm may need to refactor this field
    question: Question;
    answer: string;
    error: StsNotification;
    internalId: string;
    hiddenQuestionIds: string[];
}
